// pages/Dashboard.jsx
import Cart from "../../components/home/Cart";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <Cart />
    </HomeLayout>
  );
}
